import React from "react";

export default React.memo(function EyeIcon() {
    return (
        <svg
            width="18"
            height="18"
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M10.9885 10.8855C10.4611 11.3857 9.74591 11.6666 8.99998 11.6666C8.254 11.6666 7.53883 11.3857 7.01144 10.8855C6.48388 10.3854 6.18767 9.70727 6.18767 8.99992C6.18767 8.29257 6.48392 7.61442 7.01144 7.11434C7.53883 6.6141 8.254 6.33322 8.99998 6.33322C9.74595 6.33322 10.4611 6.61413 10.9885 7.11434C11.5161 7.61442 11.8123 8.29257 11.8123 8.99992C11.8123 9.70727 11.516 10.3854 10.9885 10.8855ZM9.66288 8.37136C9.48699 8.20472 9.24863 8.11109 8.99998 8.11109C8.75132 8.11109 8.51298 8.20472 8.33708 8.37136C8.16134 8.53815 8.0626 8.76416 8.0626 8.99994C8.0626 9.23572 8.16134 9.46173 8.33708 9.62852C8.51297 9.79516 8.75132 9.88879 8.99998 9.88879C9.24863 9.88879 9.48698 9.79516 9.66288 9.62852C9.83862 9.46173 9.93736 9.23572 9.93736 8.99994C9.93736 8.76416 9.83862 8.53815 9.66288 8.37136Z"
                fill="#1D1D1B"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M15.9697 10.74C14.9059 12.3333 12.5834 15 9 15C5.41673 15 3.09423 12.3334 2.03032 10.74C1.68391 10.2192 1.5 9.61588 1.5 9C1.5 8.38412 1.68392 7.78082 2.03032 7.25998C3.09415 5.66666 5.41673 3 9 3C12.5833 3 14.9058 5.66662 15.9697 7.25998C16.3161 7.78082 16.5 8.38412 16.5 9C16.5 9.61588 16.3161 10.2192 15.9697 10.74ZM9 4.77764C6.28616 4.77764 4.43008 6.99989 3.60974 8.21102C3.45329 8.44741 3.37041 8.72087 3.37041 8.99988C3.37041 9.27889 3.45329 9.55235 3.60974 9.78874C4.42999 10.9999 6.28616 13.2221 9 13.2221C11.7138 13.2221 13.5677 10.9999 14.3903 9.7866C14.5462 9.55033 14.6289 9.27736 14.6289 8.99881C14.6289 8.72008 14.5462 8.4471 14.3903 8.21102C13.5675 6.99989 11.7138 4.77764 9 4.77764Z"
                fill="#1D1D1B"
            />
        </svg>
    );
});